import { Stack, Title, Group, SegmentedControl } from '@mantine/core';
import { useState } from 'react';
import { DemoKanban } from './DemoKanban';
import { CompanyListPage } from './CompanyListPage';

export function DemoManagementPage() {
  const [view, setView] = useState<string>('kanban');

  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={2}>Demo-Anfragen</Title>
        <SegmentedControl
          value={view}
          onChange={setView}
          data={[
            { label: 'Kanban', value: 'kanban' },
            { label: 'Liste', value: 'list' },
          ]}
        />
      </Group>

      {view === 'kanban' ? <DemoKanban /> : <CompanyListPage filterDemo />}
    </Stack>
  );
}
